import createReducer from 'data/shared/createReducer';
import { book as actions } from 'data/booking/constants/action_types';
import without from 'lodash/without';
import omit from 'lodash/omit';
import moment from 'moment';
import reverse from "lodash/reverse";
import isEmpty from "lodash/isEmpty";
import {
    STAGE_ADD_SERVICE,
    STAGE_CHOOSE_ROUTE,
    STAGE_CHOOSE_SERVICE,
    STAGE_EDIT_SERVICE,
    STAGE_SUMMARY
} from "../constants/stages";
import {isEqual} from "lodash";
import {equals} from "../selectors/form";

const initialState = {
    isLoadingApp: true,
    submit: {
        isLoading: false,
        showForm: false,
        successful: false,
        isValid: false,
        termsReaded: false
    },
    saveDraft: {
        isLoading: false,
        successful: false
    },
    getDraft: {
        isFetching: false,
        successful: null,
        draftCount: null
    },
    serviceAdd: {
        showServices: false,
        requestData: false,
        serviceType: null,
        data: {}
    },
    editingService: null,
    editingItem: null,
    editingEndUser: false,
    routes: {
        isFetching: false,
        list: []
    },
    lines: {
        isFetching: false,
        list: []
    },
    data: {
        customer: null,
        endUser: null,
        quotationId: null,
        reference: null,
        services: [],
        clientData: null,
        comment: '',
        type: 'quotation'
    },
    entities: {
        services: {},
        routes: {},
        lines: {},
        items: {},
        originalItems: {}
    },
    currentStage: STAGE_CHOOSE_ROUTE,
    isUpdating: false
};

const unload = (state, action) => ({
    ...initialState
});

const requestUserSession = (state, action) => state;

const receiveUserSession = (state, action) => ({
    ...state,
    isLoadingApp: false,
    data: {
        ...state.data,
        customer: action.data
    }
});

const submitEndUser = (state, action) => ({
    ...state,
    editingEndUser: false,
    data: {
        ...state.data,
        endUser: {
            ...omit(action.data, ["clientId", "clientEmail"]),
        }
    }
});

const editEndUser = (state, action) => ({
    ...cancelAll(state, action),
    editingEndUser: true,
});

const cancelAll = (state, action) => ({
    ...state,
    serviceAdd: {
        ...initialState.serviceAdd
    },
    submit: {
        ...initialState.submit
    },
    saveDraft: {
        ...initialState.saveDraft
    },
    editingService: null,
    editingItem: null,
    editingEndUser: false,
    currentStage: !isEmpty(state.entities.services) ? STAGE_SUMMARY : STAGE_CHOOSE_ROUTE,
}
)

const showAddService = (state, action) => {
    const newState = {
        ...cancelAll(state, action)
    };

    return {
        ...newState,
        serviceAdd: {
            ...newState.serviceAdd,
            showServices: true
        }
    };
};

const closeAddService = (state, action) => ({
    ...state,
    currentStage: STAGE_CHOOSE_ROUTE,
    serviceAdd: {
        ...initialState.serviceAdd
    }
});

const requestServiceData = (state, action) => ({
    ...state,
    currentStage: STAGE_EDIT_SERVICE,
    serviceAdd: {
        ...state.serviceAdd,
        requestData: true,
        serviceType: action.serviceType,
        data: {
            ...state.serviceAdd.data
        }
    }
});

const addServiceData = (state, action) => ({
    ...state,
    currentStage: action.stage,
    serviceAdd: {
        ...state.serviceAdd,
        data: {
            ...state.serviceAdd.data,
            ...action.data
        }
    }
});

const submitService = (state, action) => ({
    ...state,
    pristine: false,
    serviceAdd: {
        ...initialState.serviceAdd
    },
    editingService: action.data.id,
    data: {
        ...state.data,
        services: [
            ...state.data.services,
            action.data.id
        ]
    },
    entities: {
        ...state.entities,
        services: {
            ...state.entities.services,
            [action.data.id]: {
                ...action.data.data,
                id: action.data.id,
                type: action.data.type,
                summary: '',
                price: {
                    amount: 0,
                    currency: 'EUR',
                },
                items: [],
                isNew: true
            }
        }
    }
});

const cancelAddService = (state, action) => ({
    ...cancelAll(state, action),
    serviceAdd: {
        ...initialState.serviceAdd,
        showServices: true
    }
});

const removeService = (state, action) => {
    const service = state.entities.services[action.serviceId];

    let newState = {
        ...state
    };

    service.items.forEach(itemId => {
        newState = doRemoveServiceItem(newState, action.serviceId, itemId);
    });

    const services = omit(newState.entities.services, action.serviceId)

    return {
        ...newState,
        currentStage: !isEmpty(services) ? STAGE_SUMMARY : STAGE_CHOOSE_ROUTE,
        pristine: false,
        editingService: action.serviceId == newState.editingService ? null : newState.editingService,
        data: {
            ...newState.data,
            services: without(newState.data.services, action.serviceId)
        },
        entities: {
            ...newState.entities,
            services
        }
    };
};

const requestRoutes = (state, action) => ({
    ...state,
    routes: {
        ...state.routes,
        isFetching: true,
        list: []
    }
});

const receiveRoutes = (state, action) => ({
    ...state,
    routes: {
        ...state.routes,
        isFetching: false,
        list: action.data.result
    },
    entities: {
        ...state.entities,
        routes: action.data.entities.routes
    }
});

const requestShuttleLines = (state, action) => ({
    /*...state,
    lines: {
        ...state.lines,
        isFetching: true,
        list: []
    }*/
    ...state,
    routes: {
        ...state.routes,
        isFetching: true,
        list: []
    }
});

const receiveShuttleLines = (state, action) => ({
    /*...state,
    lines: {
        ...state.lines,
        isFetching: false,
        list: action.data.result
    },
    entities: {
        ...state.entities,
        lines: action.data.entities.lines
    }*/
    ...state,
    routes: {
        ...state.routes,
        isFetching: false,
        list: action.data.result
    },
    entities: {
        ...state.entities,
        routes: action.data.entities.routes
    }
});

const toggleEditServiceItem = (state, action) => {
    const isSameItem = action.itemId == state.editingItem;

    const service = state.entities.services[action.serviceId]

    return {
        ...state,
        currentStage: STAGE_EDIT_SERVICE,
        serviceAdd: {
            ...initialState.serviceAdd,
            data: {
                route: service.route,
                hike: service.hike
            }
        },
        editingService: isSameItem ? null : action.serviceId,
        editingItem: isSameItem ? null : action.itemId
    };
};

const addServiceItem = (state, action) => ({
    ...cancelAll(state, action),
    currentStage: STAGE_EDIT_SERVICE,
    editingService: action.serviceId,
});

const submitServiceItem = (state, action) => {
    const service = state.entities.services[action.serviceId];

    return {
        ...state,
        pristine: false,
        currentStage: action.stage,
        entities: {
            ...state.entities,
            services: {
                ...state.entities.services,
                [action.serviceId]: {
                    ...service,
                    items: [
                        ...service.items,
                        action.data.id
                    ]
                }
            },
            items: {
                ...state.entities.items,
                [action.data.id]: {
                    ...omit(action.data, 'subcontractor', 'subcontractorPrice'),
                    serviceId: action.serviceId,
                    isNew: true,
                    updateStatus: state.isUpdating ? 'added' : null
                }
            }
        }
    };
};

const updateServiceItem = (state, action) => {
    let isUpdating = false;
    if(state.isUpdating){
        if(!state.entities.originalItems[action.itemId]){
            isUpdating = true
        } else {
            const type = state.entities.services[action.serviceId].type

            let newItem = {
                ...omit(state.entities.items[action.itemId], 'updateStatus'),
                ...omit(action.data, 'subcontractor', 'subcontractorPrice'),
            }
            let oldItem = {
                ...omit(state.entities.originalItems[action.itemId], 'subcontractor', 'subcontractorPrice', 'updateStatus'),
            }

            isUpdating = !equals(type, newItem, oldItem)
        }
    }

    return {
        ...state,
        pristine: false,
        entities: {
            ...state.entities,
            items: {
                ...state.entities.items,
                [action.itemId]: {
                    ...state.entities.items[action.itemId],
                    ...omit(action.data, 'subcontractor', 'subcontractorPrice'),
                    updateStatus: state.isUpdating && isUpdating ? (state.entities.items[action.itemId].updateStatus == 'added' ? 'added' : 'edited') : null
                }
            }
        }
    };
};

const sortItems = (items, state) => {
    return items.sort((a, b) => {
        const timestampA = moment(state.entities.items[a].date).valueOf();
        const timestampB = moment(state.entities.items[b].date).valueOf();

        if (timestampA < timestampB) {
            return -1;
        }

        if (timestampA > timestampB) {
            return 1;
        }

        return 0;
    });
};

const sortServiceItems = (state, action) => {
    const service = state.entities.services[action.serviceId];
    if(service) {
        return {
            ...state,
            entities: {
                ...state.entities,
                services: {
                    ...state.entities.services,
                    [action.serviceId]: {
                        ...service,
                        items: sortItems(service.items, state)
                    }
                }
            }
        }
    }
    return state
};

const doRemoveServiceItem = (state, serviceId, itemId) => {
    const service = state.entities.services[serviceId];

    return {
        ...state,
        pristine: false,
        editingService: serviceId == state.editingService ? null : state.editingService,
        editingItem: itemId == state.editingItem ? null : state.editingItem,
        entities: state.isUpdating && state.entities.items[itemId].updateStatus != 'added' ? {
                ...state.entities,
                items: {
                    ...state.entities.items,
                    [itemId]: {
                        ...state.entities.items[itemId],
                        updateStatus: 'deleted'
                    }
                }
            } :
            {
                ...state.entities,
                services: {
                    ...state.entities.services,
                    [serviceId]: {
                        ...service,
                        items: without(service.items, itemId)
                    }
                },
                items: omit(state.entities.items, itemId)
            }
    };
};

const removeServiceItem = (state, action) => doRemoveServiceItem(state, action.serviceId, action.itemId);

const changeComment = (state, action) => ({
    ...state,
    data: {
        ...state.data,
        comment: action.comment
    }
});

const showSubmit = (state, action) => ({
    ...state,
    editingService: null,
    editingItem: null,
    submit: {
        ...state.submit,
        showForm: true
    }
});

const submit = (state, action) => ({
    ...state,
    submit: {
        ...state.submit,
        isLoading: true
    }
});

const submitSuccess = (state, action) => ({
    ...state,
    submit: {
        ...state.submit,
        showForm: false,
        isLoading: false,
        successful: true,
    },
    data: {
        ...state.data,
        quotationId: action.data.quotationId,
        reference: action.data.reference
    }
});

const submitFailure = (state, action) => ({
    ...state,
    submit: {
        ...state.submit,
        isLoading: false,
        successful: false,
        isValid: false,
        termsReaded: false,
    }
});

const saveDraft = (state, action) => ({
    ...state,
    saveDraft: {
        ...state.submit,
        isLoading: true
    }
});

const saveDraftSuccess = (state, action) => ({
    ...state,
    saveDraft: {
        ...state.submit,
        isLoading: false,
        successful: true,
    },
    data: {
        ...state.data,
        quotationId: action.data.quotationId,
        reference: action.data.reference
    }
});

const saveDraftFailure = (state, action) => ({
    ...state,
    saveDraft: {
        ...state.submit,
        isLoading: false,
        successful: false
    }
});

const termsReaded = (state, action) => ({
    ...state,
    submit: {
        ...state.submit,
        isLoading: false,
        successful: false,
        termsReaded: true,
    }
});

const termsAccepted = (state, action) => ({
    ...state,
    submit: {
        ...state.submit,
        isLoading: false,
        successful: false,
        isValid: true,
        termsReaded: true,
    }
});

const termsRejected = (state, action) => ({
    ...state,
    submit: {
        ...state.submit,
        isLoading: false,
        successful: false,
        isValid: false,
        termsReaded: true,
    }
});

const loadSession = (state, action) => ({
    ...action.state.booking,
    currentStage: STAGE_SUMMARY,
    isLoadingApp: state.isLoadingApp,
    editingService: null,
});

const setStage = (state, action) => ({
    ...state,
    currentStage: action.stage,
    editingService: action.stage == STAGE_EDIT_SERVICE ? state.editingService : null 
});

const receiveDraft = (state, action) => {
    const reservationId = action.data.result;
    const reservation = action.data.entities.reservations[reservationId];

    let mergedServices = structuredClone(action.data.entities.services)
    let servicesId = Object.keys(mergedServices)
    if(!isEmpty(action.data.entities.pendingServices)) {
        Object.keys(action.data.entities.pendingServices).forEach(serviceId => {
            if (!servicesId.includes(serviceId)) {
                mergedServices[serviceId] = structuredClone(action.data.entities.pendingServices[serviceId])
            } else {
                action.data.entities.pendingServices[serviceId].items.forEach(itemId => {
                    if(!mergedServices[serviceId].items.includes(itemId)){
                        mergedServices[serviceId].items.push(itemId)
                    }
                })
            }
        })
    }

    return {
        ...state,
        currentStage: STAGE_SUMMARY,
        entities: {
            ...omit(action.data.entities, 'pendingItems', 'pendingServices'),
            items: {
                ...action.data.entities.items,
                ...action.data.entities.pendingItems,
            },
            originalItems: {
                ...action.data.entities.items,
                ...action.data.entities.pendingItems,
            },
            services: mergedServices,
            reservations: {
                [reservationId]: {
                    ...reservation,
                    history: reverse(reservation.history),
                    services: Object.keys(mergedServices)
                }
            }
        },
        data: {
            ...state.data,
            type: reservation.type,
            services: Object.keys(mergedServices),
            reference: action.reference,
            endUser: action.endUser ? {
                ...action.endUser.name,
                ...omit(action.endUser, 'name'),
            } : null,
            startAt: reservation.startAt,
            clientData: action.clientData,
        },
        getDraft: {
            successful: true,
            isFetching: false,
        },
        isFetching: false,
        isUpdating: reservation.status != 'draft',
        result: action.data.result
    }
};

const requestDraft = (state, action) => ({
    ...state,
    getDraft: {
        successful: null,
        isFetching: true
    },
});

const receiveDraftError = (state, action) => ({
    ...state,
    getDraft: {
        successful: false,
        isFetching: false
    },
});

const requestDraftCount = (state, action) => ({
    ...state,
    getDraft: {
        ...state.getDraft,
        draftCount: null,
        isFetching: true
    },
});

const receiveDraftCount = (state, action) => ({
    ...state,
    getDraft: {
        ...state.getDraft,
        isFetching: false,
        draftCount: action.draftCount
    },
});

const submitClientData = (state, action) => ({
    ...state,
    data: {
        ...state.data,
        clientData: action.data,
    }
})

export default createReducer(initialState, {
    [actions.UNLOAD]: unload,
    [actions.REQUEST_USER_SESSION]: requestUserSession,
    [actions.RECEIVE_USER_SESSION]: receiveUserSession,
    [actions.REQUEST_SERVICE_DATA]: requestServiceData,
    [actions.SUBMIT_END_USER]: submitEndUser,
    [actions.EDIT_END_USER]: editEndUser,
    [actions.SHOW_ADD_SERVICE]: showAddService,
    [actions.CLOSE_ADD_SERVICE]: closeAddService,
    [actions.ADD_SERVICE_DATA]: addServiceData,
    [actions.SUBMIT_SERVICE]: submitService,
    [actions.ADD_SERVICE_ITEM]: addServiceItem,
    [actions.SUBMIT_SERVICE_ITEM]: submitServiceItem,
    [actions.UPDATE_SERVICE_ITEM]: updateServiceItem,
    [actions.REMOVE_SERVICE_ITEM]: removeServiceItem,
    [actions.SORT_SERVICE_ITEMS]: sortServiceItems,
    [actions.CANCEL_ADD_SERVICE]: cancelAddService,
    [actions.TOGGLE_EDIT_SERVICE_ITEM]: toggleEditServiceItem,
    [actions.REMOVE_SERVICE]: removeService,
    [actions.REQUEST_ROUTES]: requestRoutes,
    [actions.RECEIVE_ROUTES]: receiveRoutes,
    [actions.REQUEST_SHUTTLE_LINES]: requestShuttleLines,
    [actions.RECEIVE_SHUTTLE_LINES]: receiveShuttleLines,
    [actions.CHANGE_COMMENT]: changeComment,
    [actions.SHOW_SUBMIT]: showSubmit,
    [actions.SUBMIT]: submit,
    [actions.SUBMIT_SUCCESS]: submitSuccess,
    [actions.SUBMIT_FAILURE]: submitFailure,
    [actions.SUBMIT_DRAFT]: saveDraft,
    [actions.SUBMIT_DRAFT_SUCCESS]: saveDraftSuccess,
    [actions.SUBMIT_DRAFT_FAILURE]: saveDraftFailure,
    [actions.CANCEL]: cancelAll,
    [actions.TERMS_READED]: termsReaded,
    [actions.TERMS_ACCEPTED]: termsAccepted,
    [actions.TERMS_REJECTED]: termsRejected,
    [actions.REQUEST_DRAFT_QUOTE]: requestDraft,
    [actions.RECEIVE_DRAFT_QUOTE]: receiveDraft,
    [actions.RECEIVE_DRAFT_QUOTE_ERROR]: receiveDraftError,
    [actions.REQUEST_DRAFT_COUNT]: requestDraftCount,
    [actions.RECEIVE_DRAFT_COUNT]: receiveDraftCount,
    [actions.LOAD_SESSION]: loadSession,
    [actions.SET_STAGE]: setStage,
    [actions.SUBMIT_CLIENT_DATA]: submitClientData,
});
